import { trackEvent } from './src/utils/analytics';
import { captureAttribution } from './src/utils/attribution';

const CONSENT_KEY = 'medical_life_cookie_consent';

function initFacebookPixel() {
  if (typeof window === 'undefined' || window.fbq) return;

  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ?
      n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
  }(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', '1574833533580914');
  trackEvent('PageView', { custom: false });
}

function initAdRoll() {
  if (typeof window === 'undefined' || window.__adroll_loaded) return;

  window.adroll_adv_id = "NPE2ABKSZBAPXAG6S2C3XA";
  window.adroll_pix_id = "TCNP3VQLV5CS3FXMVJOZ7V";
  window.adroll_version = "2.0";

  (function (w, d, e, o, a) {
    w.__adroll_loaded = true;
    w.adroll = w.adroll || [];
    w.adroll.f = ['setProperties', 'identify', 'track', 'identify_email', 'get_cookie'];
    var roundtripUrl = "https://s.adroll.com/j/" + w.adroll_adv_id + "/roundtrip.js";
    for (a = 0; a < w.adroll.f.length; a++) {
      w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || function (n) {
        return function () { w.adroll.push([n, arguments]); };
      }(w.adroll.f[a]);
    }
    e = d.createElement('script');
    o = d.getElementsByTagName('script')[0];
    e.async = 1;
    e.src = roundtripUrl;
    o.parentNode.insertBefore(e, o);
  })(window, document);

  window.adroll.track("pageView");
}

function initLinkedIn() {
  if (typeof window === 'undefined' || window.lintrk) return;

  window._linkedin_partner_id = "8462177";
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(window._linkedin_partner_id);

  (function (l) {
    if (!l) {
      window.lintrk = function (a, b) { window.lintrk.q.push([a, b]); };
      window.lintrk.q = [];
    }
    var s = document.getElementsByTagName("script")[0];
    var b = document.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);
  })(window.lintrk);
}

function initThirdPartyPixels() {
  initFacebookPixel();
  initAdRoll();
  initLinkedIn();
}

if (typeof window !== 'undefined') {
  window.__mcInitPixels = initThirdPartyPixels;
}

export const onInitialClientRender = () => {
  captureAttribution();

  const consent = localStorage.getItem(CONSENT_KEY);

  if (consent === 'granted') {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      });
    }
    initThirdPartyPixels();
  }

  document.addEventListener("click", (event) => {
    let target = event.target;
    while (target && target.tagName !== "A") {
      target = target.parentNode;
    }

    if (target && target.tagName === "A" && target.href) {
      if (target.href.startsWith("tel:")) {
        if (typeof window.fbq === "function") {
          window.fbq("trackCustom", "CTA_Phone");
        }
      }
    }
  });
};

export const onRouteUpdate = () => {
  trackEvent('PageView', { custom: false });
};
